export default __webpack_public_path__ + "static/media/aboutCp.ea0057e2.png";